import React from 'react';
import { Button } from '../../../../../UiKit';

export const ExpiredMapView = React.memo(({ refreshMap }) => {
  return (
    <div className='expiredState'>
      <div className='bgImg'></div>
      <div className='tw-flex tw-h-full tw-items-center tw-justify-center tw-w-full tw-p-4 tw-leading-snug'>
        <p className='tw-text-300 tw-leading-normal'>Map view expired!!</p>
        <p className='tw-text-300 tw-leading-normal'>
          Please reload the map to see the delivery partner’s current location
        </p>
        <div
          className='tw-h-1 tw-px-5 tw-py-5 tw-border-solid tw-border-green-700 tw-border-[1px] tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-text-200 tw-text-green-700 tw-cursor-pointer tw-mt-2'
          onClick={refreshMap}
        >
          Reload Map
        </div>
      </div>
    </div>
  );
});
